<template>
  <div>
    <Index v-if="this.$store.getters.isOturum"></Index>
    <Giris v-if="!this.$store.getters.isOturum"></Giris>
  </div>
</template>
<script>
import Index from './comp/Index'
import Giris from './pages/Giris/Index'

export default {
  components: {
    Index,
    Giris
  },
  data() {
    return {
      lo: false,
      Logo: null
    }
  },
  beforeCreate() {
  },
  created() {
    this.$store.dispatch("initAuth");



  }
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue